export const DEFAULT = {
    allLocations: 'ALL',
    expensesCategories: [
        'alquiler',
        'compra de productos e insumos',
        'gastos administrativos',
        'mantenimiento y reparaciones',
        'mercadeo y publicidad',
        'muebles, equipos o maquinaria',
        'nómina',
        // FINA-2847: categoría de los gastos que generan las salidas de inventario (mermas, robos,
        // vencidos, consumo propio...). El backend la escribe automáticamente; acá está para que sea
        // filtrable en Gastos. Ver api/src/constants/inventoryOutputReasons.constants.ts
        'salida de inventario',
        'servicios públicos',
        'transporte, domicilios y logistica',
        'otros',
    ],
    igtf: 0.03,
    iva: 0.16,
    location: 'cualquiera',
    variation: 'cualquiera',
    emptyLocation: 'sin ubicación',
};
